import { FormFieldGroup, FormLabel, FormTextarea } from '$components'
import { Input } from './index'

export function EditNotesContent() {
  return (
    <div className="flex flex-col gap-stack-section">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Notes}>
          Notes
        </FormLabel>

        <FormTextarea
          name={Input.Notes}
          placeholder="Enter internal notes..."
          rows={4}
        />
      </FormFieldGroup>
    </div>
  )
}
